window.KENT = window.KENT || {};
window.KENT.account = window.KENT.account || {};


window.KENT.account.pwdShow = {

	toggle: function($el){
		switch ($el.attr('type')) {
			case 'password':
				this.showPassword($el);
				break;
			case 'text':
				this.hidePassword($el);
				break;
		}
	},

	showPassword: function($el){
		$el.attr('type', 'text');
	},

	hidePassword: function($el){
		$el.attr('type', 'password');
	}

};


window.KENT.account.pwdAssess = {

	assessCriteria: function(password){
		if ('undefined' === typeof password){
			password = '';
		}

		var criteria = {};

		criteria.length = /^.{14,}$/.test(password);
		criteria.whitelist = /^[\!\@\#\$\%\^\&\*\(\)\_\+\-\=\{\}\[\]\\\"\;\'\<\>\?\,\.\/A-z0-9]+$/.test(password);

		criteria.lowercase = /[a-z]+/.test(password);
		criteria.uppercase = /[A-Z]+/.test(password);
		criteria.number = /[0-9]+/.test(password);
		criteria.symbol = /[\!\@\#\$\%\^\&\*\(\)\_\+\-\=\{\}\[\]\\\"\;\'\<\>\?\,\.\/]+/.test(password);

		var score = 0;
		if (criteria.lowercase){ score++; }
		if (criteria.uppercase){ score++; }
		if (criteria.number){ score++; }
		if (criteria.symbol){ score++; }
		criteria.complexity = (score >= 3);

		return criteria;
	},

	assessComplexity: function(password){
		var assessment = zxcvbn(password);
		return { score: assessment.score, warning: assessment.feedback.warning };
	},

	assessValidity: function(password) {
		var criteria = this.assessCriteria(password);
		return (criteria.length && criteria.whitelist && criteria.complexity);
	},

	assessMatch: function(password, repeat){
		return (password === repeat);
	},

	redraw: function(password, repeat) {
		// Assess validity
		var validity = this.assessValidity(password);

		// Assess password complexity. Set a score based on validity + complexity.
		var complexity = this.assessComplexity(password);

		var score = validity ? (2 + complexity.score) : 1; // 1=invalid, 2=valid+0, 3=valid+1.
		$('.password-complexity__progress').val(score);

		// Update the .password-complexity__ with state
		var $strength = $('.password-complexity__label');

		switch (score) {
			case 6:
				$strength.text('Strength: Great!');
				break;
			case 5:
				$strength.text('Strength: Good');
				break;
			case 4:
				$strength.text('Strength: OK');
				break;
			case 3:
				$strength.text('Strength: Weak');
				break;
			case 2:
				$strength.text('Strength: Very Weak');
				break;
			case 1:
				$strength.text('Strength: Invalid');
				break;
		}



		// Update .password-complexity__tips with the complexity messages
		if (complexity.warning) {
			$('.password-complexity__warning.tip-prompt').html(complexity.warning + ': <a href="#password-tips">Tips</a>');
			$('.password-complexity__warning.initial-tip-prompt').hide();
		}  else  {
			$('.password-complexity__warning.tip-prompt').html('');
		}

		// Show initial tip prompt if backspaced to an empty field
		if (password.length === 0) {
			$('.password-complexity__warning.initial-tip-prompt').show();
		} else {
			$('.password-complexity__warning.initial-tip-prompt').hide();
		}

		// Assess compliance with password criteria
		var criteria = this.assessCriteria(password);

		$('.kf-check.length').toggleClass('valid', criteria.length);
		$('.kf-check.lowercase').toggleClass('valid', criteria.lowercase);
		$('.kf-check.uppercase').toggleClass('valid', criteria.uppercase);
		$('.kf-check.number').toggleClass('valid', criteria.number);
		$('.kf-check.symbol').toggleClass('valid', criteria.symbol);

		// Use Validity to update the state of the New Password field
		var errors = [];

		$('.form-group.new-password')
			.toggleClass('has-success', validity)
			.toggleClass('has-danger', !validity)
		;

		$('.form-group.new-password .form-control')
			.toggleClass('valid', validity)
			.toggleClass('invalid', !validity)
			.toggleClass('form-control-success', validity)
			.toggleClass('form-control-danger', !validity)
		;

		var $ve = $('.form-group.new-password .validation-errors');
		$ve.find('.validation-error-js').remove();

		if (password.length && !criteria.whitelist) {
			$ve.append('<span class="validation-error validation-error-js">You appear to have used a forbidden character.</span>');
		}

		// Repeat New Password field
		var match = this.assessMatch(password, repeat);

		if (repeat && repeat.length) {
			$('.form-group.repeat-new-password')
				.toggleClass('has-success', match)
				.toggleClass('has-danger', !match)
			;

			$('.form-group.repeat-new-password .form-control')
				.toggleClass('valid', match)
				.toggleClass('invalid', !match)
				.toggleClass('form-control-success', match)
				.toggleClass('form-control-danger', !match)
			;

			$ve = $('.form-group.repeat-new-password .validation-errors');
			$ve.find('.validation-error-js').remove();

			if (!match) {
				$ve.append('<span class="validation-error validation-error-js">Your passwords must match.</span>');
			}
		}

		// Block form progression
		$('.form-actions [type="submit"]').prop('disabled', !(validity && match));
	}

};

jQuery(document).ready(function($){

	var $new = $('.form-group.new-password input');
	var $repeat = $('.form-group.repeat-new-password input');

	// Block form progression on page load. This gets re-enabled by pwdAssess.
	$('.form-actions [type="submit"]').prop('disabled', true);

	// Assess password for strength and validity whenever it changes.
	var pwdAssess = window.KENT.account.pwdAssess;

	if (($new.val().length > 0) || ($repeat.val().length > 0)){
		pwdAssess.redraw($new.val(), $repeat.val());
	}

	$new.on('keyup', function(){
		var t = setTimeout(function(){
			clearTimeout(t);
			pwdAssess.redraw($new.val(), $repeat.val());
		}, 300);
	});

	$repeat.on('keyup', function(){
		var t = setTimeout(function(){
			clearTimeout(t);
			pwdAssess.redraw($new.val(), $repeat.val());
		}, 300);
	});

	// Enable the 'Show' toggle on the password field.
	var pwdShow = window.KENT.account.pwdShow;

	var $show,
		$shows = $([]);

	$show = $('<label class="c-input c-checkbox show-password"><input type="checkbox" tabindex="1" /><span class="c-indicator"></span> Show</label>');
	$new.after($show);
	$shows = $shows.add($show);

	$show = $('<label class="c-input c-checkbox show-password"><input type="checkbox" tabindex="1" /><span class="c-indicator"></span> Show</label>');
	$repeat.after($show);
	$shows = $shows.add($show);

	$shows = $shows.find('input');
	$shows.on('change', function (e) {
		$shows.prop('checked', $(e.target).prop('checked'));

		pwdShow.toggle($new);
		pwdShow.toggle($repeat);
	});
});
